import React from "react";
import { DialogActions, Button, Fade, useTheme, useMediaQuery } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";

const DialogActionsSection = ({ handleClose, onReadingMode }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Fade in timeout={500}>
      <DialogActions
        sx={{
          p: { xs: 1.5, sm: 2 },
          borderTop: "1px solid rgba(0, 0, 0, 0.05)",
          background: "linear-gradient(145deg, #ffffff, #f8f9fa)",
          display: "flex",
          flexDirection: { xs: "column-reverse", sm: "row" },
          justifyContent: "space-between",
          gap: { xs: 1, sm: 0 },
        }}
      >
        <Button
          onClick={onReadingMode}
          variant="outlined"
          startIcon={<AutoStoriesIcon />}
          fullWidth={isMobile}
          sx={{
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600,
            px: { xs: 2, sm: 3 },
            py: { xs: 1.25, sm: 1 },
            fontSize: { xs: "0.875rem", sm: "0.9375rem" },
            minHeight: { xs: "44px", sm: "auto" },
            color: "primary.main",
            borderColor: "primary.main",
            "&:hover": {
              backgroundColor: "rgba(18, 141, 111, 0.05)",
              borderColor: "primary.dark",
            },
            "&:active": {
              backgroundColor: "rgba(18, 141, 111, 0.1)",
            },
          }}
        >
          Reading Mode
        </Button>
        <Button
          onClick={handleClose}
          variant="outlined"
          startIcon={<CloseIcon />}
          fullWidth={isMobile}
          sx={{
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600,
            px: { xs: 2, sm: 3 },
            py: { xs: 1.25, sm: 1 },
            fontSize: { xs: "0.875rem", sm: "0.9375rem" },
            minHeight: { xs: "44px", sm: "auto" },
            color: "text.secondary",
            borderColor: "rgba(0, 0, 0, 0.1)",
            "&:hover": {
              borderColor: "primary.main",
              color: "primary.main",
              backgroundColor: "rgba(18, 141, 111, 0.05)",
            },
            "&:active": {
              backgroundColor: "rgba(18, 141, 111, 0.1)",
            },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Fade>
  );
};

export default DialogActionsSection;
